import { useEffect } from 'react';
import Hero from '../../components/Hero/Hero';
import Features from '../../components/Features/Features';
import VideoSection from '../../components/VideoSection/VideoSection';
import Screenshots from '../../components/Screenshots/Screenshots';
import Footer from '../../components/Footer/Footer';
// import Outsourcing from '../../components/Outsourcing/Outsourcing';
import Pricing from '../../components/Pricing/Pricing';
import SetupDownload from '../../components/SetupDownload/SetupDownload';
import fnc from '../../components/mymod/commFunction';
import './Home.scss';

const VIEW_COUNT_INCREASE_INTERVAL_MS = 60 * 60 * 1000;

const Home = ({ disableHomePageRoutesApi = false }) => {
  useEffect(() => {
    if (disableHomePageRoutesApi) {
      return;
    }

    const storageKey = 'homeViewCount_lastIncreaseAt';
    const now = Date.now();
    const lastIncreaseAt = Number(sessionStorage.getItem(storageKey) || 0);
    const shouldIncrease = now - lastIncreaseAt > VIEW_COUNT_INCREASE_INTERVAL_MS;

    if (shouldIncrease) {
      sessionStorage.setItem(storageKey, String(now));
      fnc.sendAxios('/homePageRoutes/increaseViewCount', { pageKey: 'home' }, () => {});
      return;
    }

    fnc.sendAxios('/homePageRoutes/selectViewCount', { pageKey: 'home' }, () => {});
  }, [disableHomePageRoutesApi]);

  return (
    <main className="home">
      <Hero />



      <Features />
      <VideoSection />
      <Screenshots />
      <Pricing />
      <SetupDownload disableHomePageRoutesApi={disableHomePageRoutesApi} />
      <div className="ownership-notice">PROVIDED BY 매쓰테일러</div>
      

      {/* <Footer /> */}
  

    </main>


  );
};

export default Home;



